<template>
   <SecondMenu />
</template>
<script>
  import SecondMenu from '../index/SecondMenu'

  export default {
    data () {
      return {
}
},
components: {
"SecondMenu": SecondMenu
}
}
</script>



// WEBPACK FOOTER //
// src/components/set/set.vue